import { defineComponent as _defineComponent } from 'vue'
import EnglishProfileAiCard from '@/components/yagiprime/EnglishProfileAiCard.vue'
import {
  MAX_PR_MESSAGE_LENGTH,
  useEnglishResumeFormatData
} from '@/composables/format-edit/useEnglishResumeFormatData'


export default /*#__PURE__*/_defineComponent({
  __name: 'EnglishResumePrMessageCard',
  props: {
    currentCardId: null
  },
  setup(__props: any) {



const formatData = useEnglishResumeFormatData()

function handleAdoptProfile(text: string) {
  formatData.prMessage = text
}

return { __sfc: true,formatData, handleAdoptProfile, EnglishProfileAiCard, MAX_PR_MESSAGE_LENGTH }
}

})